import { render, staticRenderFns } from "./AccidentTimeIndividualForm.vue?vue&type=template&id=12c92d15&scoped=true"
import script from "./AccidentTimeIndividualForm.vue?vue&type=script&lang=js"
export * from "./AccidentTimeIndividualForm.vue?vue&type=script&lang=js"
import style0 from "./AccidentTimeIndividualForm.vue?vue&type=style&index=0&id=12c92d15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c92d15",
  null
  
)

export default component.exports